/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div[_ngcontent-%COMP%]{display:flex;align-items:center;padding-left:10px;padding-right:10px;cursor:pointer}svg[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };
